import React from 'react';
import { Brain, Target, Users, Rocket, MessageSquare, CheckCircle, Wrench } from 'lucide-react';

export default function Features() {
  const features = [
    {
      icon: <Brain className="w-6 h-6 text-blue-500" />,
      title: 'Yenzo - Your Finance Gekko',
      description: 'Your friendly finance buddy, helping you understand your numbers with a smile'
    },
    {
      icon: <Target className="w-6 h-6 text-blue-500" />,
      title: 'Kabuki - Your Marketing Gekko',
      description: 'Your creative marketing companion, bringing fresh ideas to your brand'
    },
    {
      icon: <Rocket className="w-6 h-6 text-blue-500" />,
      title: 'Shogun - Your Sales Gekko',
      description: 'Your enthusiastic sales partner, helping you connect with customers'
    },
    {
      icon: <Wrench className="w-6 h-6 text-blue-500" />,
      title: 'Seisaku - Your Production Gekko',
      description: 'Your methodical project manager, turning ideas into reality with precision'
    },
    {
      icon: <Users className="w-6 h-6 text-blue-500" />,
      title: 'Seamless Collaboration',
      description: "Your Gekkos work together under Kari's coordination, sharing insights and ideas"
    },
    {
      icon: <MessageSquare className="w-6 h-6 text-blue-500" />,
      title: 'Natural Communication',
      description: 'Chat naturally with your AI team members anytime, anywhere'
    },
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Your AI Management Team</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Meet your friendly team of AI specialists, working together with a smile to help you succeed
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 bg-gradient-to-br from-blue-50 to-white rounded-xl border border-blue-100 hover:shadow-lg transition-all"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-white p-2 rounded-lg shadow-sm">
                  {feature.icon}
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}